import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { formatNumar } from "@/utils/targetareFormatting";

type PaginareProps = {
  pagina: number;
  randuriPePagina: number;
  total: number;
  selectate: number;
  onPagina: (pagina: number) => void;
};

export function Paginare({
  pagina,
  randuriPePagina,
  total,
  selectate,
  onPagina,
}: PaginareProps) {
  const ultima = Math.max(1, Math.ceil(total / randuriPePagina));
  const primul = total === 0 ? 0 : (pagina - 1) * randuriPePagina + 1;
  const ultimul = Math.min(pagina * randuriPePagina, total);
  return (
    <div className="flex flex-wrap items-center justify-between gap-2 border-t bg-muted/30 px-3 py-1.5 text-sm">
      <span className="text-ds-blue-700 tabular-nums">
        {selectate > 0 ? `${formatNumar(selectate)} rânduri selectate` : ""}
      </span>
      <div className="flex items-center gap-1 tabular-nums">
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          disabled={pagina <= 1}
          onClick={() => onPagina(1)}
          aria-label="Prima pagină"
        >
          <ChevronsLeft className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          disabled={pagina <= 1}
          onClick={() => onPagina(pagina - 1)}
          aria-label="Pagina anterioară"
        >
          <ChevronLeft className="h-4 w-4" />
        </Button>
        <span className="rounded bg-muted px-2 py-0.5 text-xs">{pagina}</span>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          disabled={pagina >= ultima}
          onClick={() => onPagina(pagina + 1)}
          aria-label="Pagina următoare"
        >
          <ChevronRight className="h-4 w-4" />
        </Button>
        <Button
          variant="ghost"
          size="sm"
          className="h-7 w-7 p-0"
          disabled={pagina >= ultima}
          onClick={() => onPagina(ultima)}
          aria-label="Ultima pagină"
        >
          <ChevronsRight className="h-4 w-4" />
        </Button>
        <span className="ml-2 text-muted-foreground">
          {formatNumar(primul)} - {formatNumar(ultimul)} din{" "}
          {formatNumar(total)}
        </span>
      </div>
    </div>
  );
}
